module.exports = __webpack_public_path__ + "static/mega8k-721fbd4a819b0982f48135420e5325a2.png";